export default __webpack_public_path__ + "static/media/icon-layers.f5c92150.svg";